import { useQuery } from '@tanstack/react-query';
import { Select, SelectProps, Typography } from 'antd';
import { getAssetsDropdown } from 'src/apis/master_data/asset.api';
const { Text } = Typography;

export default function AssetsSelect({
  value,
  onChange,
  style,
  allowClear = true,
  placeholder,
  disabled
}: SelectProps) {
  const assetsDropdownQuery = useQuery({
    queryKey: ['assetsDropdown'],
    queryFn: () => getAssetsDropdown(),
    staleTime: 60 * 1000
  });

  return (
    <Select
      disabled={disabled}
      allowClear={allowClear}
      value={assetsDropdownQuery.isFetching ? undefined : value}
      style={style}
      onChange={onChange}
      options={assetsDropdownQuery.data?.data.map((data) => ({
        value: JSON.stringify(data),
        label: <Text>{data.assetCode}</Text>
      }))}
      showSearch
      filterOption={(input, option) => (option?.label?.toString() ?? '').toLowerCase()?.includes(input.toLowerCase())}
      placeholder={placeholder}
      loading={assetsDropdownQuery.isFetching}
    />
  );
}
